"use client";

import React from "react";

import { createSVGIcon } from "../util";

export const CheckInCircle = createSVGIcon(
  <>
    <path
      d="M0.571289 8.00004C0.571289 9.97022 1.35394 11.8597 2.74707 13.2528C4.14019 14.646 6.02968 15.4286 7.99986 15.4286C9.97004 15.4286 11.8595 14.646 13.2527 13.2528C14.6458 11.8597 15.4284 9.97022 15.4284 8.00004C15.4284 6.02986 14.6458 4.14038 13.2527 2.74725C11.8595 1.35412 9.97004 0.571472 7.99986 0.571472C6.02968 0.571472 4.14019 1.35412 2.74707 2.74725C1.35394 4.14038 0.571289 6.02986 0.571289 8.00004V8.00004Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.90479 8.73763L6.20669 10.4119C6.25048 10.4682 6.30636 10.5139 6.37019 10.5457C6.43402 10.5775 6.50418 10.5946 6.57549 10.5956C6.6468 10.5967 6.71743 10.5817 6.78217 10.5518C6.84691 10.5219 6.90411 10.4778 6.94955 10.4229L11.0953 5.4043"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CheckInCircle",
  {
    viewBox: "0 0 16 16",
    fill: "none",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
